import Vue from 'vue';
import useJwt from '@core/auth/jwt/useJwt';
import axios from '@axios';

const {jwt} = useJwt(axios, {});

Vue.prototype.$useJwt = jwt;
export default jwt;
